// Every message property the email-to-metadata mapping can resolve
// (EmailMapper.getOfficeJSToEmailMapping). `from` is preferred over `sender`
// for send-on-behalf mail; conversationIndex backs the ConversationIndex /
// ConversationID column mappings.
//
// Single source of truth for every Graph request that feeds the
// selectedExchangeItems header cache (OutlookService multi-select,
// ExchangeService selected-emails/message fetches): a field added to the
// mapping but missing from one producer's $select would make that flow
// silently resolve the column to empty.
export const messageHeaderSelectFields: string = "id,subject,from,sender,sentDateTime,receivedDateTime,toRecipients,ccRecipients,bccRecipients,categories,conversationId,conversationIndex,hasAttachments,internetMessageId,replyTo,importance";
